// src/api.js
const inferBase = () => {
  const envBase = (import.meta?.env?.VITE_API_BASE || process.env.REACT_APP_API_BASE || '').trim();
  if (envBase) return envBase;

  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    if (origin.startsWith('https://guiqiantec.com') || origin.startsWith('https://www.guiqiantec.com')) {
      return ''; // 同域反代，直接用相对路径 /api/...
    }
  }
  return 'http://localhost:3010'; // 本地开发
};

// ✅ 导出给需要拼接 URL 的场景（比如 SSE/文件下载等）
export const API_BASE = inferBase();

// ✅ 仅拼接 URL，不发请求（适合 SSE）
export function apiUrl(path) {
  const p = String(path || '');
  if (!API_BASE) return p; // 同域时返回相对路径
  return `${API_BASE}${p.startsWith('/') ? p : `/${p}`}`;
}
// api.js
export async function apiFetch(
  path,
  { method = 'GET', body, headers = {}, raw = false, signal } = {}
) {
  const token = localStorage.getItem('token');
  const url = /^https?:\/\//i.test(path) ? path : `${API_BASE}${path}`;

  const init = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    body:
      body == null
        ? undefined
        : typeof body === 'string'
          ? body
          : JSON.stringify(body),
    signal,
  };

  const res = await fetch(url, init);

  // ✅ raw: 直接返回原始 Response（SSE/文件流用），上层自己解析
  if (raw) return res;

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(text || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }

  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) return res.json();
  return res.text();
}
